import { BazaNcPayoffDistributionImportCsvEntryError } from '../models/baza-nc-payoff-distribution-import-csv-entry-error';
import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';

export class BazaNcPayoffDistributionImportCsvEntryErrorDto {
    @ApiModelProperty({
        description: 'CSV Line (excepts header)',
    })
    row: number;

    @ApiModelProperty({
        type: 'string',
        enum: Object.values(BazaNcPayoffDistributionImportCsvEntryError),
        description: 'Error type',
    })
    reason: BazaNcPayoffDistributionImportCsvEntryError;

    @ApiModelProperty({
        description: 'Exception (for "Exception" reason only)',
        required: false,
    })
    exception?: string;
}
